import React from 'react';
import { Group, Rect, Line } from 'react-konva';

function Panjere({ x, y, length, angleDeg, thickness = 8, selected = false, onPointerDown }) {
  const color = selected ? '#0a66c2' : '#000000';

  return (
    <Group x={x} y={y} rotation={angleDeg} onPointerDown={onPointerDown}>
      <Rect x={-6} y={-thickness / 2 - 10} width={length + 12} height={thickness + 20} fill="#000000" opacity={0} />
      <Rect
        x={0}
        y={-thickness / 2}
        width={length}
        height={thickness}
        fill="#ffffff"
        stroke={color}
        strokeWidth={selected ? 2 : 1}
      />
      <Line points={[0, 0, length, 0]} stroke={color} strokeWidth={selected ? 2.5 : 1.5} />
    </Group>
  );
}

export default Panjere;